<div class="pmcc-page">

  <app-header></app-header>

  <div class="pmcc-page-content">
    <router-outlet></router-outlet>
  </div>

  <pmac-footer type="publisher" class="footer" data-pm-id="pmac-footer"></pmac-footer>

</div>
